import type { FaireThemeEntity } from "../../entity_types/theme";

export const discovery_theme_travel_accessories: FaireThemeEntity = {
  token: "discovery_theme_travel-accessories",
  type: "theme",
  retailerToken: "r_discovery",
  name: "Travel Accessories",
  description: "Wanderlust-ready gear and travel goods",
  bgColor: "#D8D4E8",
  productTokens: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
